(function () {
  'use strict';

  /* ── Shade Finder Modal ── */
  var modal = document.getElementById('bb-sf-modal');
  if (!modal) return;

  var answers = {};
  var currentStep = 0;

  var SHADE_MAP = {
    'Fair/Light_Everyday_Soft': 'bare-affair',
    'Fair/Light_Everyday_Bold': 'hush-honey',
    'Fair/Light_Evening_Soft':  'hush-honey',
    'Fair/Light_Evening_Bold':  'divine',
    'Medium/Tan_Everyday_Soft': 'hush-honey',
    'Medium/Tan_Everyday_Bold': 'divine',
    'Medium/Tan_Evening_Soft':  'own-it',
    'Medium/Tan_Evening_Bold':  'own-it',
    'Deep/Rich_Everyday_Soft':  'own-it',
    'Deep/Rich_Everyday_Bold':  'deep-truth',
    'Deep/Rich_Evening_Soft':   'girls-girl',
    'Deep/Rich_Evening_Bold':   'deep-truth',
  };

  var shadesJson = null;
  try {
    var el = modal.closest('[data-shades-json]') || document.querySelector('[data-shades-json]');
    if (el) shadesJson = JSON.parse(el.dataset.shadesJson);
  } catch (e) {}

  if (!shadesJson) {
    shadesJson = [
      { id: 'bare-affair', name: 'Bare Affair', hex: '#EEC0AC', tag: 'Sheer nude',  url: '/products/soft-lip-blur-bare-affair-3ml' },
      { id: 'hush-honey',  name: 'Hush Honey',  hex: '#D09060', tag: 'Warm honey',  url: '/products/soft-lip-blur-hush-honey-3ml' },
      { id: 'divine',      name: 'Divine',      hex: '#C06878', tag: 'Rosy mauve',  url: '/products/soft-lip-blur-divine-3ml' },
      { id: 'own-it',      name: 'Own It',      hex: '#7A2838', tag: 'Berry brown', url: '/products/soft-lip-blur-own-it-3ml-copy' },
      { id: 'deep-truth',  name: 'Deep Truth',  hex: '#5C1428', tag: 'Deep wine',   url: '/products/soft-lip-blur-deep-truth-3ml' },
      { id: 'girls-girl',  name: 'Girls Girl',  hex: '#D45870', tag: 'Warm pink',   url: '/products/soft-lip-blur-girls-girl-3ml' },
    ];
  }

  function openModal() {
    currentStep = 0;
    answers = {};
    showStep(0);
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function showStep(step) {
    modal.querySelectorAll('.bb-sf-modal__step').forEach(function (s) {
      s.classList.remove('active');
    });
    var target = modal.querySelector('[data-step="' + (step === 'result' ? 'result' : step) + '"]');
    if (target) target.classList.add('active');
  }

  function getRecommendation() {
    var key = answers.tone + '_' + answers.occasion + '_' + answers.finish;
    var id = SHADE_MAP[key] || 'own-it';
    return shadesJson.find(function (s) { return s.id === id; }) || shadesJson[3];
  }

  function showResult() {
    var shade = getRecommendation();
    document.getElementById('bb-sf-result-name').textContent = shade.name + '.';
    document.getElementById('bb-sf-result-body').textContent =
      'A ' + shade.tag.toLowerCase() + ' that suits ' + answers.tone.toLowerCase() +
      ' skin and ' + answers.occasion.toLowerCase() + ' wear, in a ' + answers.finish.toLowerCase() + ' finish.';
    document.getElementById('bb-sf-result-swatch').style.background = shade.hex;
    document.getElementById('bb-sf-result-product').textContent = 'Soft Lip Blur · ' + shade.name;
    var shopBtn = document.getElementById('bb-sf-shop-btn');
    shopBtn.href = shade.url || '/collections/all';
    showStep('result');
  }

  /* Trigger buttons (any .bb-sf-modal-trigger on the page) */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.bb-sf-modal-trigger')) openModal();
    if (e.target === modal) closeModal();
    if (e.target.closest('#bb-sf-close')) closeModal();
  });

  /* Answer buttons */
  modal.addEventListener('click', function (e) {
    var opt = e.target.closest('.bb-sf-modal__opt');
    if (!opt) return;
    var keys = ['tone', 'occasion', 'finish'];
    answers[keys[currentStep]] = opt.dataset.answer;
    currentStep++;
    if (currentStep < 3) {
      showStep(currentStep);
    } else {
      showResult();
    }
  });

  /* Retake */
  var retakeBtn = document.getElementById('bb-sf-retake');
  if (retakeBtn) {
    retakeBtn.addEventListener('click', function () {
      currentStep = 0;
      answers = {};
      showStep(0);
    });
  }

  /* Keyboard close */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* Newsletter form success flash */
  var nlForm = document.getElementById('bb-newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = nlForm.querySelector('[type="email"]');
      if (!emailInput || !emailInput.value) return;
      nlForm.innerHTML = '<div class="bb-newsletter__success bb-eyebrow" style="color:var(--bb-blush)">✓ You\'re on the list. Watch your inbox.</div>';
    });
  }
})();
